export function validate_required(value, label, message = "") {
    if (!String(value || "").trim()) {
        return message || `${label} is required.`;
    }

    return "";
}

export function validate_person_name(value, label) {
    const required_error = validate_required(value, label);

    if (required_error) {
        return required_error;
    }

    if (!/^[\p{L}][\p{L}\s'-]*$/u.test(String(value).trim())) {
        return `${label} can only use letters, spaces, apostrophes, or hyphens.`;
    }

    return "";
}

export function validate_email(value, label = "Email") {
    const required_error = validate_required(value, label);

    if (required_error) {
        return required_error;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim())) {
        return "Enter a valid email address.";
    }

    return "";
}

export function validate_phone_number(value, label = "Phone number") {
    const required_error = validate_required(value, label);

    if (required_error) {
        return required_error;
    }

    if (!/^\d{10}$/.test(String(value).trim())) {
        return `${label} must be 10 digits.`;
    }

    return "";
}

export function assign_error(errors, key, message) {
    if (message) {
        errors[String(key)] = message;
    }
}
